/**
 * Cloudflare Turnstile: el captcha del acceso, el alta y «olvidé la contraseña».
 *
 * Encendido solo si el build trae `VUE_APP_TURNSTILE_SITE_KEY`. Apagado no se
 * carga el script, no se pinta nada y los formularios no mandan `captcha_token`
 * (el backend tampoco lo exige si no tiene `TURNSTILE_SECRET`).
 *
 * El script se pide UNA vez por página (`render=explicit`: cada widget lo pinta
 * su componente) y desde el único origen que la CSP le abre.
 */
export const TURNSTILE_SITE_KEY: string = process.env.VUE_APP_TURNSTILE_SITE_KEY || '';
export const turnstileEncendido: boolean = TURNSTILE_SITE_KEY.trim() !== '';

const SCRIPT_URL = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';

export interface OpcionesTurnstile {
  sitekey: string;
  callback: (token: string) => void;
  'expired-callback': () => void;
  'error-callback': () => void;
  language?: string;
}

export interface ApiTurnstile {
  render(el: HTMLElement, opciones: OpcionesTurnstile): string;
  reset(widgetId?: string): void;
  remove(widgetId?: string): void;
}

let cargando: Promise<ApiTurnstile> | null = null;

function apiGlobal(): ApiTurnstile | undefined {
  return (window as unknown as { turnstile?: ApiTurnstile }).turnstile;
}

export function cargarTurnstile(): Promise<ApiTurnstile> {
  const yaEsta = apiGlobal();
  if (yaEsta) return Promise.resolve(yaEsta);
  if (cargando) return cargando;
  cargando = new Promise<ApiTurnstile>((resolve, reject) => {
    const script = document.createElement('script');
    script.src = SCRIPT_URL;
    script.async = true;
    script.defer = true;
    script.onload = () => {
      const api = apiGlobal();
      if (api) {
        resolve(api);
        return;
      }
      cargando = null;
      reject(new Error('turnstile: el script cargó sin exponer window.turnstile'));
    };
    script.onerror = () => {
      // Se puede reintentar recargando: no se queda envenenada la promesa.
      cargando = null;
      script.remove();
      reject(new Error('turnstile: no se pudo cargar el script'));
    };
    document.head.appendChild(script);
  });
  return cargando;
}
